<template>
  <div class="user">
    <div class="photo">
      <md-icon style="margin-left:5px; color: #FFF">flag</md-icon>
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li v-for="lang in langOptions" v-bind:key="lang">
                <a href="#" @click="set_language(lang)">
                  <span class="sidebar-mini">{{ lang }}</span>
                  <span class="sidebar-normal">{{ lang }}</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: "Language",
    },
    rtlTitle: {
      type: String,
      default: "تانيا أندرو",
    },
    avatar: {
      type: String,
      default: "./img/faces/avatar.jpg",
    },
  },
  data() {
    return {
      isClosed: true,
      langOptions: [],
    };
  },
  async mounted() {
    this.langOptions = ["nl", "en"];
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    set_language: function(lang) {
      this.$i18n.locale = lang;
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
